import { createRouter, createWebHistory } from "vue-router";
import Home from "@/views/Home/index.vue";
import Login from "@/views/Login/index.vue";
import StoreDetail from "@/views/StoreDetail/index.vue";
import ProductDetail from "@/views/ProductDetail/index.vue";
import OrderConfirm from "@/views/OrderConfirm/index.vue";
import MyOrder from "@/views/MyOrder/index.vue";
import OrderDetail from "@/views/OrderDetail/index.vue";
import STAR from "@/views/STAR/index.vue";
import MUSE from "@/views/MUSE/index.vue";
import MUSEIntro from "@/views/MUSEIntro/index.vue";
import Test from "@/views/Test/index.vue";
import AddressList from "@/views/Address/index.vue";
import NewAddress from "@/views/Address/NewAddress.vue";
import Payment from "@/views/Payment/index.vue";
import OtherPayment from "@/views/OtherPayment/index.vue";
import CreditCardPayment from "@/views/CreditCardPayment/index.vue";
import PaySuccess from "@/views/STAR/PaySuccess.vue";
import PayFail from "@/views/STAR/PayFail.vue";
import StarPay from "@/views/STAR/StarPay.vue";
import IntegralIndex from "@/views/Integral/index.vue";
import IntegralDetail from "@/views/Integral/IntegralProductDetail/index.vue";
import IntegralList from "@/views/Integral/IntegralProductList/index.vue";
import IntegralRecords from "@/views/Integral/IntegralRecords/index.vue";
import IntegralTransactions from "@/views/Integral/IntegralTransactions/index.vue";
import SubmitOrder from "@/views/SubmitOrderPage/index.vue";
import ReplacePayment from '@/views/ReplacePayment/index.vue';
import { useI18n } from 'vue-i18n';
import i18n from '../locales';
import _service from "@/service";
import { showToast } from "vant";
import { iframePost } from "@/utils";

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: "/",
      redirect: "/home",
    },
    {
      path: "/home",
      name: "Home",
      component: Home,
      meta: { keepAlive: true},
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
      meta: { keepAlive: true},
    },
    {
      path: "/store-detail",
      name: "StoreDetail",
      component: StoreDetail,
      meta: { keepAlive: true,title:i18n.global.t('Store Details')},
    },
    {
      path: "/product-detail/:id",
      name: "ProductDetail",
      component: ProductDetail,
      meta: { keepAlive: true,title:i18n.global.t('Product Details')},
    },
    {
      path: "/order-confirm",
      name: "OrderConfirm",
      component: OrderConfirm,
      meta: { keepAlive: true,title:i18n.global.t('Order Confirmation Page')},
    },
    {
      path: "/my-order",
      name: "MyOrder",
      component: MyOrder,
      meta: { keepAlive: true,title:i18n.global.t('My Orders')},
    },
    {
      path: "/order-detail",
      name: "OrderDetail",
      component: OrderDetail,
      meta: { keepAlive: true,title:i18n.global.t('Order Details')},
    },
    {
      path: "/star",
      name: "STAR",
      component: STAR,
      meta: { keepAlive: true,title:i18n.global.t('STAR Purchase')},
    },
    {
      path: "/star-pay",
      name: "StarPay",
      component: StarPay,
      meta: {title:i18n.global.t('STAR Purchase')},
    },
    {
      path: "/payment",
      name: "Payment",
      component: Payment,
      meta: {title:i18n.global.t('Payment details')},
    },
    {
      path: "/other-payment",
      name: "OtherPayment",
      component: OtherPayment,
      meta: {title:i18n.global.t('Payment details')},
    },
    {
      path: "/creditcard-payment",
      name: "CreditCardPayment",
      component: CreditCardPayment,
      meta: {title:i18n.global.t('Payment details')},
    },
    {
      path: "/address-list",
      name: "AddressList",
      component: AddressList,
      meta: {title:i18n.global.t('Address management')},
    },
    {
      path: "/new-address/:id?",
      name: "NewAddress",
      component: NewAddress,
      meta: {title:i18n.global.t('New address')},
    },
    {
      path: "/pay-success",
      name: "PaySuccess",
      component: PaySuccess,
      meta: { keepAlive: true,title:i18n.global.t('Payment successful')},
    },
    {
      path: "/pay-fail",
      name: "PayFail",
      component: PayFail,
      meta: { keepAlive: true,title:i18n.global.t('Payment failed')},
    },
    {
      path: "/muse-stake",
      name: "MUSE",
      component: MUSE,
      meta: { keepAlive: true,title:i18n.global.t('Staking MUSE')},
    },
    {
      path: "/muse-intro",
      name: "MUSEIntro",
      component: MUSEIntro,
      meta: { keepAlive: true,title:'MUSE'},
    },
    {
      path: "/integral/index",
      name: "IntegralIndex",
      component: IntegralIndex,
      meta: { keepAlive: true,title:i18n.global.t('Integral Mall')},
    },
    {
      path: "/integral/list",
      name: "IntegralList",
      component: IntegralList,
      meta: { keepAlive: true,title:i18n.global.t('All Products')},
    },
    {
      path: "/integral/records",
      name: "IntegralRecords",
      component: IntegralRecords,
      meta: { keepAlive: true,title:i18n.global.t('Integral Records')},
    },
    {
      path: "/integral/transactions",
      name: "IntegralTransactions",
      component: IntegralTransactions,
      meta: { keepAlive: true,title:i18n.global.t('Transaction Details')},
    },
    {
      path: "/submit-order",
      name: "SubmitOrder",
      component: SubmitOrder,
      meta: {title:i18n.global.t('Payment details')},
    },
    {
      path: "/replace-payment",
      name: "ReplacePayment",
      component: ReplacePayment,
      meta: {title:i18n.global.t('Payment details')},
    },
    {
      path: "/integral/detail/:id",
      name: "IntegralDetail",
      component: IntegralDetail,
      meta: { keepAlive: true,title:i18n.global.t('Product Details')},
    },
    {
      path: "/integral",
      redirect: "/integral/index",
    },
    
    {
      path: "/test",
      name: "Test",
      component: Test,
      meta: { keepAlive: true},
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
      // return { top: 0 };
    } else {
      return { top: 0 };
    }
  },
});


// 全局前置守卫
router.beforeEach(async(to, from, next) => {
  //重置页面有弹窗不让滚动的特性 防止如果有页面跳走之前忘记关闭弹窗
  document.body.style.overflow = "inherit"

  // 生产环境从链接进去带token
  if (to.query.token) {
    sessionStorage.setItem('APLINK_STARNEST_TOKEN',`${to.query.token}`)
  }
  // if (!sessionStorage.getItem('APLINK_STARNEST_TOKEN')) {
  //   iframePost('needlogin')
  // }
  // 根据iframe传的语言更改语言
  if (to.query.locale) {
    localStorage.setItem('starnest-locale',`${to.query.locale}`)
    i18n.global.locale.value = to.query.locale as string
  }
  if (to.query.currency) {
    sessionStorage.setItem('currency',`${to.query.currency}`)
  }
  if (to.query.account) {
    sessionStorage.setItem('STARNEST_ACCOUNT',`${to.query.account}`)
  }
  if (to.query.ORDER_DATA) {
    sessionStorage.setItem('ORDER_DATA',`${to.query.ORDER_DATA}`)
  }
  if (to.query.parentUrl) {
    sessionStorage.setItem('PARENT_URL',`${to.query.parentUrl}`)
  }

  // 支付完回跳带参处理
  if (to.path === '/payment' && to.query.resultCode) {
    if (to.query.resultCode === '0000') {
      next('/pay-success')
    }else{
      next('/pay-fail')
    }
  }
  if (to.path === '/payment' && to.query.trade_status) {
    if (to.query.trade_status === 'TRADE_FINISHED') {
      next('/pay-success')
    }else{
      next('/pay-fail')
    }
  }
  
  // 根据路由信息修改title
  if (to.meta && to.meta.title) {
    document.title = to.meta.title;
  }else{
    document.title = i18n.global.t('Mall')
  }
  next();
});


export default router;
